import ApiService from './ApiService';

const PagePrototypeService = {
  list: async () => ApiService.get('/page-prototypes'),
  getById: async (id) => ApiService.get(`/page-prototypes/${id}`),
  create: async (payload) => ApiService.post('/page-prototypes', payload),
  update: async (id, payload) => ApiService.put(`/page-prototypes/${id}`, payload),
  deletePrototype: async (id) => ApiService.delete(`/page-prototypes/${id}`),
  deleteBlock: async (prototypeId, blockId) =>
    ApiService.delete(`/page-prototypes/${prototypeId}/blocks/${blockId}`),
  updateBlockStatus: async (prototypeId, blockId, status) =>
    ApiService.patch(`/page-prototypes/${prototypeId}/blocks/${blockId}/status`, { status }),
  getSettings: async () => ApiService.get('/page-prototypes/settings'),
  updateSettings: async (payload) =>
    ApiService.patch('/page-prototypes/settings', payload),
  searchBlocks: async (payload) =>
    ApiService.post('/page-prototypes/search-blocks', payload),
  searchPrototypes: async (payload) =>
    ApiService.post('/page-prototypes/search-prototypes', payload),
  importUrlsFile: async (file, projectId) => {
    const formData = new FormData();
    const safeName = file.name.replace(/[^A-Za-z0-9._-]/g, '_');
    const safeFile = new File([file], safeName, { type: file.type });
    formData.append('urls_file', safeFile, safeName);
    formData.append('project_id', projectId);
    return ApiService.post('/page-prototypes/import-urls', formData);
  },
  uploadScreenshot: async (id, file) => {
    const formData = new FormData();
    formData.append('screenshot', file, file.name);
    return ApiService.post(`/page-prototypes/${id}/screenshot`, formData);
  },
  uploadDomJson: async (id, file) => {
    const formData = new FormData();
    formData.append('dom_json', file, file.name);
    return ApiService.post(`/page-prototypes/${id}/dom-json`, formData);
  },
};

export default PagePrototypeService;
